// ---------- ZKEX signature message for login ----------
export const AUTHORIZATION_MESSAGE =
  'Sign this message to connect with ZKEX services.\nNOTE: Please check this website ends with "app.zkex.com".'

export const GENERATE_ZKLINK_KEY_MESSAGE =
  "Sign this message to create a key to interact with zkLink's layer2 services.\nNOTE: This application is powered by zkLink protocol.\n\nOnly sign this message for a trusted client!"
